module.exports = __webpack_public_path__ + "img/banner3_3_th.8e52a698.png";